import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, StringField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class ProjectMetaBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new ProjectMetaBox({
            uuid,
            graph,
            name: "ProjectMetaBox",
            pointerRules: {
                accepts: [Pointers.ProjectMeta],
                mandatory: true,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "ProjectMetaBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitProjectMetaBox, this);
    }
    get tags() {
        return ProjectMetaBox.Tags;
    }
    get projectName() {
        return this.getField(1);
    }
    get artist() {
        return this.getField(2);
    }
    get description() {
        return this.getField(3);
    }
    get tagList() {
        return this.getField(4);
    }
    get notepad() {
        return this.getField(5);
    }
    get created() {
        return this.getField(6);
    }
    get modified() {
        return this.getField(7);
    }
    get coverId() {
        return this.getField(8);
    }
    initializeFields() {
        return {
            1: StringField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "projectName",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "artist",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "description",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: StringField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "tagList",
                deprecated: false,
                pointerRules: NoPointers,
            }, "[]"),
            5: StringField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "notepad",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            6: StringField.create({
                parent: this,
                fieldKey: 6,
                fieldName: "created",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            7: StringField.create({
                parent: this,
                fieldKey: 7,
                fieldName: "modified",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            8: StringField.create({
                parent: this,
                fieldKey: 8,
                fieldName: "coverId",
                deprecated: false,
                pointerRules: NoPointers,
            }),
        };
    }
}
